
module.exports = {
  menuList: {
    home: 'Home',
    survey: 'Survey',
    service: 'Service',
    exhibition: 'Exhibition',
    information: 'Information',
    collection: 'Collection',
    socialEducation: 'Social education',
    culturalCreation: 'Cultural creation',
    reSearch: 'Research'
  },
  footterList: {
    huaianMuseumSummary: 'Jingan museum summary',
    WeaveConstruction: 'Weave construction',
    manager: 'Manager',
    decisionAndSupervisoryOrgan: 'Decision and supervisory organ',
    scholarshipCommittee: 'Scholarship committee',
    serviceGuide: "Service guide",
    visit: 'Visit',
    volunteer: 'Volunteer',
    members: 'Members',
    inspection: 'Inspection',
    news: 'News',
    partyBuilding: 'Party building',
    ruleAndProject: 'Rule and project',
    managerialSystem: 'Managerial system',
    muckle: 'Muckle',
    civilizationConstruction: 'Civilization construction',
    standingExhibition: 'Standing exhibition',
    temporaryExhibition: 'Temporary exhibition',
    abductionExchange: 'Abduction exchange',
    virtualWalkthrough: 'Virtual walkthrough',
    culturalRelicToAppreciate: 'Cultural relic to appreciate',
    choicestCollection: 'Choicest collection',
    pedagogicalActivity: 'Pedagogical activity',
    huaianMuseumRostrum: 'Jingan museum rostrum',
    culturalAndOriginalProduct: 'Cultural and original product',
    shopintroction: 'Shop introction',
    academicResearch: 'Academic research',
    collectionDatabase: 'Collection database',
    learning: 'Learning',

    academicWorks: 'Academic works',
    dataIndexing: 'Data indexing',
    huaianHistory: "History of Jing'an",

    potteryFigurine: 'Pottery figurine',
    culturalRelicsOf3D: 'Cultural relics of 3D',
    ceramics: 'Ceramics',
    jadeWare: 'JadeWare',
    ironBronzeWare: 'IronBronzeWare',
    paintingAndCalligraphy: 'Painting and calligraphy',
  },
  sponsoredByHuaiMuseum: "sponsored by Huai'an Museum",
  //首页
  onLineReserve: 'OnLine reserve',
  activityPreview: 'Preview activity',
  more: 'More',
  transportationGuide: 'transportation guide',
  huaianNews: "Jingan's News",
  excellentCollection: 'Excellent collection',
  fujianDownload: 'Download',
  //服务
  trafficRoute: 'Traffic route',
  busStation: 'Bus station',
  address: 'Address',
  preliminaryInstructions: 'Preliminary instructions',
  volunteerRules: 'Volunteer rules',
  volunteerDownload: 'Volunteer download',
  societiesOfMuseumFriendsRoules: 'Societies of museum friends roules',
  societiesOfMuseumFriendsDownload: 'Societies of museum friends Download',
  //展览
  exhibitionCategory: 'Exhibition category',
  perennialDisplay: 'Perennial display',
  freeOfVCharge: 'Free of vCharge',
  exhibitionHall: 'Exhibition hall',
  exhibitionTime: 'Exhibition time',
  exhibitionAddress: 'Exhibition address',
  organizer: 'Organizer',
  exhibitionContent: 'Exhibition content',
  //资讯
  releaseTime: 'Release time',
  details: 'Details',
  //common
  schedule: 'Schedule',
  // 典藏
  locationOfExhibitionHall: 'Location of exhibition hall',
  times: 'Times',
  timeSpecification: 'Time specification',
  source: 'Source',
  number: 'Number',
  collectDetails_details: 'Details',
  level: 'Level',
  //社教
  socialEducation_times: 'Times',
  socialEducation_address: 'Address',
  registrationTelephone: 'Registration telephone',
  ageRequirement: 'Age requirement',
  remainingTime: 'Remaining time',
  briefIntroduction: 'Brief introduction',
  eventDetails: 'Event details',
  //文创
  type: 'Type',
  price: 'Price',
  buy: 'Buy',
  dyf: 'Dyf',
  displaySection: 'Display section',
  showAll: 'Show all',

  //common
  viewDetails: 'View details',
  //研究
  essentialInformation: 'Essential information',
  bookName: 'BookName',
  author: 'Author',
  publish: 'publish',
  contentValidity: 'Content validity',
  //home
  WeChat: 'WeChat',
  microBlog: 'Micro-blog',
  order: 'Order',
  address1: 'Address',
  busRoutes: 'Bus routes',
  consultationTelephone: 'Consultation telephone',
}


// WEBPACK FOOTER //
// ./src/locales/en.js